import { useState } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../../elements/text/Text';
import Title from '../../elements/title/Title';
import Modal from '../../sections/modal/Modal';

const StyledSection = styled('section')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const FA2Section = ({ enabled = false, toggle2FA }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    toggle2FA();
  };

  return (
    <StyledSection>
      <Title subTitle text={t('twoFA', { ns: 'sectionTitles' })} gutterBottom />
      <Text gutterBottom>{t('twoFA', { ns: 'descriptions' })}</Text>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid>
          <Text>
            {enabled
              ? t('twoFAEnabled', { ns: 'descriptions' })
              : t('twoFADisabled', { ns: 'descriptions' })}
          </Text>
        </Grid>
        <Grid>
          <Button
            onClick={enabled ? toggle2FA : handleOpen}
            color={enabled ? 'error' : 'primary'}
          >
            {enabled
              ? t('disable2FA', { ns: 'buttons' })
              : t('enable2FA', { ns: 'buttons' })}
          </Button>
        </Grid>
      </Grid>
      <Modal
        openModal={open}
        title={t('twoFASettings', { ns: 'sectionTitles' })}
        showActions
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      >
        {t('twoFAProcess', { ns: 'descriptions' })}
      </Modal>
    </StyledSection>
  );
};

FA2Section.propTypes = {
  enabled: PropTypes.bool,
  toggle2FA: PropTypes.func.isRequired,
};

export default FA2Section;
